
import { BaseModel } from "./base.model";
import { SelectListItem } from "./select-list-item.model";

export class UserModel extends BaseModel {
  name: string;
  password: string;
  emailAddress?: string;
  mobileNumber?: string;
  active?: boolean;
  roleName?: string;
  userName: string;
  token: string;
  roleId: number = 0
  remark: string;
  isSuperAdmin:boolean;
  storeId: number = 0;
  permissions?: string[] = [];
  userAccessibleStoreList: Array<SelectListItem> = []
}


